import React, { useState, createContext, useEffect, useContext } from "react";
import {
  unstable_useBlocker,
  unstable_usePrompt,
  useParams,
} from "react-router-dom";
import { emptyPage, remove_prefix, trimPageData } from "../helpers";
import { APIProviderContext } from "../api";
import { toast } from "react-toastify";
import useInterval from "use-interval";
import _ from "lodash";
import { AccountContext } from "../account/account";
import { GrigoraDashboardContext } from "../dashboard/context";
import slugify from "slugify";

const GrigoraPreviewContext = createContext();

function GrigoraPreviewProvider({ ...props }) {
  const {
    getCMSPostData,
    getCMSPostContent,
    projectPagesData,
    getPageContent,
  } = useContext(APIProviderContext);
  const [isLoading, setIsLoading] = useState(true);
  const [noTemplateFound, setNoTemplateFound] = useState(false);
  const [postData, setPostData] = useState(null);
  const [templateData, setTemplateData] = useState(null);
  const [postTemplateContent, setTemplateContent] = useState(null);
  const [postContent, setPostContent] = useState(null);
  const { projectID, postID } = useParams();
  const [displaySize, setDisplaySize] = useState("desktop");

  const resetStates = () => {
    setIsLoading(true);
    setPostData(null);
    setPostContent(null);
  };

  async function getPostTemplate() {
    return await new Promise((resolve, reject) => {
      projectPagesData({ id: projectID }).then((projectPages) => {
        if (projectPages) {
          var template_page = projectPages.find(
            (page) => page.type === "template" && page.template === "cms-post",
          );
          if (template_page) {
            var page_id = remove_prefix(template_page.sk, "page-data-");
            getPageContent({
              project_id: projectID,
              page_id: page_id,
            })
              .then((templateContent) => {
                resolve({
                  data: template_page,
                  content: templateContent?.content,
                });
              })
              .catch((err) => {
                reject(err);
              });
          } else {
            reject();
          }
        } else {
          reject();
        }
      });
    });
  }

  const mergePostTemplateBlocks = (
    postData,
    postContent,
    templateData,
    templateContent,
  ) => {
    postContent = JSON.parse(postContent);
    templateContent = JSON.parse(templateContent);

    // Update Post Title
    var postTitleIDs = Object.keys(templateContent).filter(
      (key) => templateContent[key]["custom"]["slug"] === "grigora/post-title",
    );
    postTitleIDs.map((id) => {
      templateContent[id]["props"]["content"] = postData.title;
    });

    // Update Post Content
    var postContentIDs = Object.keys(templateContent).filter(
      (key) =>
        templateContent[key]["custom"]["slug"] === "grigora/post-content",
    );
    postContentIDs.map((id) => {
      templateContent[id]["isCanvas"] = true;
      templateContent[id]["props"]["content"] = "";
      templateContent[id]["nodes"] = postContent["ROOT"]["nodes"];
      templateContent = {
        ...postContent,
        ...templateContent,
      };
    });

    // Update Post Featured Image
    var postFeaturedImageIDs = Object.keys(templateContent).filter(
      (key) =>
        templateContent[key]["custom"]["slug"] ===
        "grigora/post-featured-image",
    );
    postFeaturedImageIDs.map((id) => {
      templateContent[id]["props"]["src"] = postData?.featured_image?.src;
      templateContent[id]["props"]["srcMode"] =
        postData?.featured_image?.srcMode;
    });

    // Update Post Date
    var postDateIDs = Object.keys(templateContent).filter(
      (key) => templateContent[key]["custom"]["slug"] === "grigora/post-date",
    );
    postDateIDs.map((id) => {
      templateContent[id]["props"]["date"] = postData?.last_update * 1000;
    });

    // Update Post Summary

    return JSON.stringify(templateContent);
  };

  useEffect(() => {
    getCMSPostData(projectID, postID)
      .then((postData) => {
        getCMSPostContent(projectID, postID)
          .then((postContent) => {
            // Get Post Template Data
            getPostTemplate()
              .then(({ data, content }) => {
                setTemplateData(data);
                setTemplateContent(content);

                setPostData(postData);
                setPostContent(
                  mergePostTemplateBlocks(
                    postData,
                    postContent?.content,
                    templateData,
                    content,
                  ),
                );

                setIsLoading(false);
              })
              .catch((err) => {
                console.log(err);
                setNoTemplateFound(true);
                setIsLoading(false);
              });
          })
          .catch((err) => {
            console.log(err);
            resetStates();
            setIsLoading(true);
          });
      })
      .catch((err) => {
        console.log(err);
        resetStates();
        setIsLoading(true);
      });
  }, []);

  return (
    <GrigoraPreviewContext.Provider
      value={{
        noTemplateFound,
        setNoTemplateFound,
        isLoading,
        projectID,
        postID,
        postData,
        setPostData,
        postContent,
        setPostContent,
        displaySize,
        setDisplaySize,
      }}
    >
      {props.children}
    </GrigoraPreviewContext.Provider>
  );
}

export { GrigoraPreviewProvider, GrigoraPreviewContext };
